<template>
    <div class="edit-list atb-flex atb-flex-column">
      <div class="atb-content-bg atb-flex atb-flex-column">
        <div class="search">
          <el-form :inline="true" :model="searchParam" class="atb-input" ref="searchForm" :rules="rules" :show-message="false" @keyup.enter.native.prevent="getList(1)" @submit.native.prevent>
  
            <el-form-item class="flex-form-item" label="部门名称" prop="departmentNo">
              <el-popover placement="bottom-start" width="420" popper-class="popper-tree declare-dep" @hide="handledHide" trigger="click">
                <el-tree
                  :props="defaultProps"
                  :data="depTreeData"
                  show-checkbox
                  node-key="id"
                  ref="tree"
                  highlight-current
                  check-strictly
                  :default-expanded-keys="expandedData"
                  :filter-node-method="filterDeptNode"
                  @check-change="handleCheckChange"
                >
                </el-tree>
                <el-input slot="reference" v-model="department" placeholder="请选择部门名称" clearable></el-input>
              </el-popover>
            </el-form-item>
            <el-form-item label="姓名">
              <selecter v-model="searchParam.wkNo"></selecter>
            </el-form-item>
            <el-form-item label="年份" prop="year">
              <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
            </el-form-item>
            <el-form-item label="期次" prop="period">
              <common-select ref="period" v-model="searchParam.period" :list="periodList" optLabel="label" optValue="value" placeholder="期次" clearable></common-select>
            </el-form-item>
            <el-form-item label="排序人" prop="configWkNo">
              <selecter v-model="searchParam.configWkNo"></selecter>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getList(1)">查询</el-button>
              <el-button type="add" @click="add">新增</el-button>
            </el-form-item>
            <el-form-item class="multi-line">
              <el-button type="downloadTemplate" @click="downloadTemplate">下载重要度配置导入模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload ref="file" :http-request="importExcel" :multiple="false" :show-file-list="false">
                <el-button type="export">导入</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="export" @click="exportExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="table-content atb-flex atb-flex-column">
          <vxe-table
            class="atb-table header-table edit-table"
            border="inner"
            height="100%"
            auto-resize
            resizable
            stripe
            highlight-hover-row
            highlight-current-row
            :data="tableData"
            ref="table"
            @cell-click="expandRow"
          >
            <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
            <vxe-table-column field="wkNo" width="80" title="工号"></vxe-table-column>
            <vxe-table-column field="wkName" width="80" title="姓名"></vxe-table-column>
            <vxe-table-column field="department" min-width="220" title="部门"></vxe-table-column>
            <vxe-table-column field="year" width="60" title="年"></vxe-table-column>
            <vxe-table-column field="period" width="80" title="期次">
              <template #default="{row}">
                <span>{{ periods[row.period] }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="configWkInfo" width="130" title="排序人"></vxe-table-column>
            <vxe-table-column field="remarks" min-width="150" title="备注">
              <template #default="{row}">
                <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remarks}}</div>
              </template>
            </vxe-table-column>
            <!-- <vxe-table-column field="isEnable" width="60" title="状态">
              <template #default="{row}">{{ row.isEnable == 1 ? '启用' : '停用' }}</template>
            </vxe-table-column> -->
  
            <vxe-table-column field="" title="操作" fixed="right" width="80" class-name="operation">
              <template #default="scope">
                <div>
                  <el-tooltip class='item' effect='dark' content='编辑' placement="bottom">
                    <i class='icon-editor' @click.stop='edit({row:scope.row})'></i>
                  </el-tooltip>
                  <el-tooltip class='item' effect='dark' content='删除' placement="bottom">
                    <i class='icon-close delete' @click.stop='deleteTip({row:scope.row})'></i>
                  </el-tooltip>
                </div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="page-con atb-flex atb-flex-justify-end">
          <vxe-pager
            background
            :current-page.sync="page.pageIndex"
            :page-size.sync="page.pageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
      </div>
  
      <common-dialog ref="updateDialog" :title="dialogContent.title" width="600px" :showClose="true">
        <template slot="content">
          <component v-bind:is="dialogContent.componentName" :editData="editRow" @submitSuccess="getList(1)"></component>
        </template>
      </common-dialog>
      <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
          <h2>确定要删除吗</h2>
          <p>已删除的项不能撤回</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
          <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  <script>
  import _ from "lodash";
  import { PERIODS, PERIOD_LIST } from '@/utils/period-enum.js';
  import periodMixin from '@/mixins/period.mixin';
  export default {
    name: 'ImportanceWeightSetting',
    mixins: [periodMixin],
    components: {
      selecter: () => import('@/component/global/customerSelect'),
      Add: () => import('./Add'),
    },
    data() {
      return {
        periods: PERIODS,
        periodList:  _.cloneDeep(PERIOD_LIST),
        loginWkNo: '',
        searchParam: {
          wkNo: '',
          configWkNo:''
        },
        page: {
          pageIndex: 1,
          pageSize: 10,
        },
        total: 0,
        tableData: [],
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        depList: [],
        department: '',
        departmentNo: '',
        expandedData: [],
        depTreeData: [],
        copyTreeData: [],
        requestMethod:'get',
         handledPage: {
          pageIndex: 1,
          pageSize: 10
        },
        handledTotal: 0,
        that: this,
        editRow: {},
        dialogContent: {},
        showDelTip: false,
      }
    },
    watch: {
      department: {
        handler(val) {
          this.$refs.tree && this.$refs.tree.filter(val);
          if (!val) {
            this.departmentNo = "";
            if (this.$refs.tree) {
              setTimeout(() => {
                const depTree = _.cloneDeep(this.copyTreeData);
                this.treeData = depTree;
              }, 10)
              this.$refs.tree.setCheckedKeys([]);
            }
          }
        },
        immediate: true,
      },
    },
    methods: {
      async getDep() {
        await this.$ajax.get(this.$api.Identity.Categord.dep, {}).then((res) => {
          this.depList = res.data || [];
          const obj = {};
          this.depList.forEach((v) => {
            const objClone = _.cloneDeep(obj);
            (objClone.id = v.id), (objClone.code = v.code), (objClone.label = v.displayName);
            if (v.parentId === null) {
              this.expandedData.push(v.id);
              objClone.children = this.depList.filter((t) => t.parentId === v.id);
              this.generateMenu(objClone.children);
              this.depTreeData.push(objClone);
              this.copyTreeData = _.cloneDeep(this.depTreeData);
            }
          });
        });
      },
      generateMenu(chs) {
        chs.forEach((v) => {
          v.label = v.displayName;
          v.children = this.depList.filter((t) => t.parentId === v.id);
          this.generateMenu(v.children);
        });
      },
      handleCheckChange(data, checked) {
        if (checked === true) {
          this.checkId = data.id;
          this.departmentNo = data.code;
          this.department = data.label;
          this.$refs.tree.setCheckedKeys([data.id]);
        } else {
          if (this.checkId === data.id) {
            this.checkId = '';
            this.departmentNo = '';
            this.department = '';
            this.$refs.tree.setCheckedKeys([]);
          }
        }
      },
      filterDeptNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      foldHistoryTree() {
        let treeList = this.depTreeData;
        //关键代码
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.tree.store.nodesMap[treeList[i].id].expanded = false;
        }
      },
      getChildrenMenu(depData){
        let depTree=[];
        depData.forEach(t=>{
          if(t.label.indexOf(this.department.split('/')[this.department.split('/').length-1]) != -1){
          depTree.push(t)
          }else{
            if(t.children && t.children && t.children.length){
              t.children = this.getChildrenMenu(t.children)
              if(t.children && t.children.length){
                depTree.push(t)
              }
            }
          }
        });
        return this.depTreeData = depTree;
      },
      handledHide(){
         this.$nextTick(()=>{
          if(!this.$refs.tree.getCheckedKeys().length){
            this.department = '';
          }
        });
      },
  
      getList(page) {
        this.setValid(1);
        this.$refs['searchForm'].validate((valid, errors) => {
          if (valid) {
            this.page.pageIndex = page;
            let param = Object.assign({ loginWkNo: this.loginWkNo, departmentNo: this.departmentNo }, this.page, this.searchParam, {year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined, period: this.searchParam.period || undefined});
            this.$ajax.post(this.$api.period.ImportantSortConfig.GetList, param).then((res) => {
              const list = res.data.rows || [];
              this.tableData = list;
              list.forEach(v=>{
                if(v.configWkInfo){
                  const arr=v.configWkInfo.split('(');
                  v.configWkNo=arr[1].split(')')[0];
                  v.configWkName=arr[0];
                }
              })
              this.total = res.data.total;
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0);
        });
      },
      handlePageChange({ currentPage }) {
        this.getList(currentPage);
      },
      add() {
        let classifyWeight = {};
        this.editRow = {
          wkNo: '',
          wkName: '',
          ...classifyWeight,
          remarks: '',
          isEnable: 1
        };
        this.dialogContent = {
          title: '新增',
          componentName: 'add'
        }
        this.$refs.updateDialog.show();
      },
      edit({row}){
        this.editRow = typeof(row) == 'object' ? _.cloneDeep(row) || {} : {};
        this.editRow.id = 'edit';
        this.editRow.year = this.editRow.year.toString();
        this.dialogContent = {
          title: '编辑',
          componentName: 'add'
        }
        this.$refs.updateDialog.show();
      },
      deleteTip({row}) {
        this.showDelTip = true;
        this.row = row;
      },
      del() {
        if (this.row.id) {
          this.$ajax.get(this.$api.period.ImportantSortConfig.DeleteImportantSortConfig, { id: this.row.id }).then(() => {
            this.$message.success('删除成功');
            this.getList(1);
          }).finally(()=>{
            this.showDelTip = false;
          });
        }
      },
      expandRow({row}) {
        row.expandRowFlag = !row.expandRowFlag;
        this.$refs.table.updateData(this.tableData);
      },
  
      downloadTemplate() {
        window.location.href = process.env.VUE_APP_PUBLICPATH + 'files/重要度配置导入模板.xlsx';
      },
      importExcel({ file }) {
        const params = new FormData();
        params.append('excelfile', file);
        this.$ajax.post(this.$api.period.ImportantSortConfig.ImportImportantSortConfig, params, { headers: { 'Content-Type': 'multipart/form-data;' } }).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.data || '上传成功');
            this.getList(1);
          }
        });
      },
      // 导出
      exportExcel() {
        this.setValid(1);
        this.$refs['searchForm'].validate(async (valid, errors) => {
          if (valid) {
            let exportParams = {
              loginWkNo: this.loginWkNo,
              ...this.searchParam,
              year: this.searchParam.year ? parseInt(this.searchParam.year) : undefined,
              period: this.searchParam.period || undefined,
              departmentNo: this.departmentNo
            }
            this.$ajax.post(this.$api.export.ImportantSortConfigExportByteAsync, exportParams, {ignore: true, responseType: 'blob'}).then((res) => {
              if (res.data.type == 'application/json') {
                var reader = new FileReader();
                reader.onload = () => {
                  var content = reader.result;//内容就在这里
                  let json = JSON.parse(content)
                  this.$message.error(json.message)
                };
                reader.readAsText(res.data);
              } else {
                const filename = '重要度排序配置'
                const filetype = 'xlsx'
                let data = res.data;
                let url = window.URL.createObjectURL(data)
                let a = document.createElement('a')
                document.body.appendChild(a)
                a.href = url
                a.download = filename + '.' + filetype
                a.click()
                window.URL.revokeObjectURL(url)
              }
            });
          } else {
            if (errors) {
              for (const key in errors) {
                this.$message.error(errors[key][0].message)
              }
            }
          }
          this.setValid(0); 
        })
      },
    },
    mounted() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.loginWkNo = userInfo ? JSON.parse(userInfo).wkNo: '';
      this.getDep();
      this.getList(1);
    }
  }
  </script>
  <style scoped lang='scss'>
  .edit-list {
    height: 100%;
    .search {
      .el-date-editor--daterange {
        width: 360px;
      }
    }
    .atb-content-bg {
      margin-top: 0px;
      padding: 20px;
      flex: 1;
    }
    ::v-deep .el-tag {
      padding: 0 8px;
      width: auto;
    }
    .plan_table {
      padding: 0 5px;
    }
    .el-link--danger {
      cursor: auto;
    }
  }
  .patch-item {
    width: 100%;
    ::v-deep .el-input__inner {
      border-radius: 4px;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }
  .declare-dep {
    height: 350px;
    width: 350px;
    overflow: auto;
  }
  .el-form-item.multi-line {
    ::v-deep .el-form-item__content {
      line-height: inherit;
    }
    .el-button.el-button--downloadTemplate {
      width: 105px!important;
      white-space: normal;
      padding: 5px 2px;
      min-height: 40px;
    }
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  </style>
  